// src/features/game/services/sseService.ts

import {
  EventSourcePolyfill,
} from 'event-source-polyfill';

import {
  store,
} from '../../../app/store';

import {
  SSE_ENDPOINTS,
} from '../../../api';

import api from '../../../api/axios';

const baseURL =
  process.env.REACT_APP_API_BASE_URL;


/**
 * SSE 데이터 파싱
 */
const parseEventData = (
  event: any,
  eventName: string,
  onMessage: (data: any) => void,
): void => {
  console.log(
    `[SSE] ${eventName} 이벤트 받음`,
  );

  console.log(
    '[SSE] event 객체:',
    event,
  );

  console.log(
    '[SSE] event.data:',
    event.data,
  );

  try {
    const data =
      JSON.parse(
        event.data,
      );

    console.log(
      `[SSE] ${eventName} 파싱된 데이터:`,
      data,
    );

    onMessage(
      data,
    );
  } catch (error) {
    console.error(
      `[SSE] ${eventName} 파싱 에러:`,
      error,
    );
  }
};


/**
 * 실제 게임 SSE 구독
 *
 * GET /api/v2/sse/subscribe
 */
export const subscribeToGame = (
  playGameId: number,

  onMessage: (
    data: any,
  ) => void,

  onError?: (
    error: Event,
  ) => void,
): (() => void) => {

  const {
    accessToken,
    tokenType,
  } = store.getState().auth;

  if (!baseURL) {
    throw new Error(
      'REACT_APP_API_BASE_URL이 설정되지 않았습니다.',
    );
  }

  if (!accessToken) {
    throw new Error(
      'Access Token이 없습니다.',
    );
  }

  const params =
    new URLSearchParams({
      playGameId:
        playGameId.toString(),
    });

  const url =
    `${baseURL}${SSE_ENDPOINTS.SUBSCRIBE}?${params.toString()}`;

  /**
   * EventSourcePolyfill을 사용하여
   * Authorization Header 포함
   */
  const eventSource =
    new EventSourcePolyfill(
      url,
      {
        headers: {
          Authorization:
            `${
              tokenType ||
              'Bearer'
            } ${accessToken}`,
        },
      },
    );


  /**
   * 기본 message 이벤트
   */
  eventSource.onmessage = (
    event: any,
  ) => {
    parseEventData(
      event,
      'message',
      onMessage,
    );
  };


  /**
   * refresh 이벤트
   */
  eventSource.addEventListener(
    'refresh',
    (
      event: any,
    ) => {
      parseEventData(
        event,
        'refresh',
        onMessage,
      );
    },
  );


  /**
   * 커스텀 SSE 이벤트
   */
  const eventNames = [
    'prizesUpdated',
    'connected',
    'gameUpdated',
    'levelUpdated',
    'playerUpdated',
  ] as const;

  eventNames.forEach(
    (
      eventName,
    ) => {
      eventSource.addEventListener(
        eventName,
        (
          event: any,
        ) => {
          parseEventData(
            event,
            eventName,
            onMessage,
          );
        },
      );
    },
  );


  /**
   * SSE 연결 오류
   */
  eventSource.onerror = (
    error: any,
  ) => {
    console.error(
      '[SSE] 연결 에러:',
      error,
    );

    onError?.(
      error,
    );
  };


  /**
   * 연결 종료
   */
  return () => {
    eventSource.close();
  };
};


/**
 * SSE 메시지 직접 발행
 *
 * ADMIN / SUPERADMIN
 *
 * POST /api/v2/admin/sse/publish
 */
export const publishSSEMessage =
  async (
    playGameId: number,
    event: string,
    data: unknown,
  ): Promise<void> => {

    await api.post(
      SSE_ENDPOINTS.ADMIN.PUBLISH,
      {
        playGameId:
          playGameId.toString(),

        event,

        data,
      },
    );
  };